import React from 'react';
import PropTypes from 'prop-types';

import styled from 'styled-components';
import { media } from '../../../styles/style-utils';
import { legacyType } from '../../../styles/typography';
import MDReactComponent from 'markdown-react-js';

import { Body, Subheader } from './ArticleGridBlock';
import ReadMore from '../utils/ReadMore';
import Hyperlink from '../../common/Hyperlink';
import ArticleSubheader from './ArticleSubheader';
import { getArtworkUrl } from '../utils/Contentful';
import { getMagazineArticleUrl } from '../../../../routes/util';

const Wrapper = styled.div`
  background-color: var(--c-ral);

  ${media.large`
    margin-right: calc(3 * var(--fr));
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-evenly;
  `};
`;

const HeroImage = styled.img`
  width: 100%;
  height: 100%;

  ${media.large`
    width: 65%;
  `};

  ${media.extraLarge`
    width: 57.5%;
  `}
`;

const TextBlock = styled.div`
  text-align: left;
  padding: var(--fr);
  flex-direction: column;
  display: flex;
  justify-content: center;

  ${media.mediumLarge`
    text-align: center;
    padding: calc(2 * var(--fr));
  `};

  .preview {
    font-size: var(--fs-sm);
    ${legacyType('sm', 'body')};
    overflow: hidden;
    -webkit-line-clamp: 4; /* stylelint-disable-line property-no-vendor-prefix */
    -webkit-box-orient: vertical; /* stylelint-disable-line property-no-vendor-prefix */
    display: -webkit-box; /* stylelint-disable-line value-no-vendor-prefix */
    word-break: break-word;

    p {
      display: inline;
    }
  }

  h2 {
    font-size: var(--fs-ml);
    margin: var(--fr) 0;
    overflow: hidden;
    -webkit-line-clamp: 2; /* stylelint-disable-line property-no-vendor-prefix */
    -webkit-box-orient: vertical; /* stylelint-disable-line property-no-vendor-prefix */
    display: -webkit-box; /* stylelint-disable-line value-no-vendor-prefix */
    word-break: break-word;
  }
`;

const ArticleHero = ({ content }) => {
  const { title, excerpt, featuredImage, slug, category } = content;
  const url = getMagazineArticleUrl(slug);

  return (
    <Wrapper>
      {slug && <Hyperlink to={url} className="dummy-btn" aria-label={title} />}
      {featuredImage && <HeroImage src={getArtworkUrl(featuredImage)} alt="" />}
      <TextBlock>
        <Subheader>
          <ArticleSubheader category={category} />
        </Subheader>
        {title && <h2>{title}</h2>}
        {excerpt && (
          <Body className="preview">
            <MDReactComponent text={excerpt} />
          </Body>
        )}
        <ReadMore />
      </TextBlock>
    </Wrapper>
  );
};

ArticleHero.propTypes = {
  content: PropTypes.object,
};

export default ArticleHero;



// WEBPACK FOOTER //
// /tmp/build_83f21ab6/src/components/main/article/ArticleHero.js